import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import LocizeBackend from "i18next-locize-backend";
const isProduction = process.env.NODE_ENV === "production";

const interpolationFormat = (value, format, lng, x) => {
  if (format === "hoursMinutes") {
    const hours = Math.floor(x.minutes / 60);
    const minutes = x.minutes % 60;
    if (hours) {
      return i18n.t("time.hours", { count: hours });
    }
    if (hours && minutes) {
      return i18n.t("time.hours_and_minutes", {
        hours: hours,
        minutes: minutes,
      });
    }
    if (minutes) {
      return i18n.t("time.minutes", { count: minutes });
    }
  }
  return value;
};
const locizeOptions = {
  projectId: window["_env"].LOCIZE_PROJECTID,
  referenceLng: "en",
  version: window["_env"].LOCIZE_VERSION,
};
i18n
  .use(ChainedBackend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ns: ["kiosk", "planetfitness", "Events", "ElementTree"],
    defaultNS: "kiosk",
    debug: !isProduction,
    fallbackLng: "en",
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      console.log("missing translation key:", lngs, ns, key);
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: interpolationFormat,
    },
    backend: {
      backends: [LocalStorageBackend, LocizeBackend],
      backendOptions: [
        // LocalStorageBackend options
        {
          // prefix for stored languages
          prefix: "i18next_",
          // expiration
          expirationTime: !isProduction
            ? 20 * 60 * 1000 // 20 min
            : 7 * 24 * 60 * 60 * 1000, // 1 week
          // Version applied to all languages, can be overridden using the option `versions`
          defaultVersion: process.env.BUILD_ID,
          // language versions
          // can be either window.localStorage or window.sessionStorage. Default: window.localStorage
          store: typeof window !== "undefined" ? window.localStorage : null,
        },
        // LocizeBackend options
        locizeOptions,
      ],
    },
  });

// preload translations
if (!isProduction) {
  i18n.addResourceBundle("en", "kiosk", require("./i18n/en/kiosk.json"));
  i18n.addResourceBundle(
    "en",
    "planetfitness",
    require("./i18n/en/planetfitness.json")
  );
}

export default i18n;
